import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import Select from "react-select";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const AddGRN = ({orderId, order}) => {
    const [currentUser, setCurrentUser] = useState(null);
    // const [purchaseOrder, setPurchaseOrder] = useState(null);
    const [purchaseOrderID, setPurchaseOrderID] = useState(null);
    const [items, setItems] = useState([]);
    const [locations, setLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(null);

    useEffect(() => {
        
        const items = order.order.items.map((item) => ({
            product_id: item.product_id,
            product_name: item.product_name || "N/A",
            unit_price: item.unit_price,
            remaining_quantity: item.remaining_quantity,
            quantity: item.quantity,
            total_price: item.total_price,
            received_quantity: item.remaining_quantity, // Initialize received quantity to 0
        }));
        setItems(items);


        const order_id = order.orderId;
        setPurchaseOrderID(order_id);
            

        const fetchCurrentUser = async () => {
        const token = sessionStorage.getItem("token");
          if (!token) {
              toast.error("Authentication token missing. Please log in.");
              return;
          }
          try {
            const response = await axios.get(
              `${API_BASE_URL}/users/specific`,
              {
              headers: { Authorization: `Bearer ${token}` },
              }
            );
            const userData = response.data;
            setCurrentUser(userData);

            // Fetch locations and products based on role
            if (userData.role === "Main Admin") {
              fetchAllLocations();
            } else if (userData.role === "Company Admin" || userData.role === "Farm User" || userData.role === "Outlet User") {
              fetchFilteredLocations(userData);
            }

          } catch (error) {
              console.error("Error fetching user data:", error);
              toast.error("Failed to fetch user data.");
          }

        };
    fetchCurrentUser();
  }, []);

  const fetchAllLocations = async () => {
    const token = sessionStorage.getItem("token");
    const response = await axios.get(
      `${API_BASE_URL}/locations`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    setLocations(response.data.locations);
  };

  const fetchFilteredLocations = async () => {
    const token = sessionStorage.getItem("token");
    const response = await axios.get(
      `${API_BASE_URL}/products/filtered-locations`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    setLocations(response.data.locations);
  };

  const handleChange = (index, field, value) => {
    const updatedItems = [...items];
    if (field === "received_quantity") {
      const maxQty = updatedItems[index].remaining_quantity;
      if (value > maxQty) {
        toast.error(`Received quantity cannot exceed remaining quantity of ${maxQty}`);
        return; // Exit without updating state
      }
      if (value < 0) {
        toast.error("Received quantity cannot be negative.");
        return;
      }
    }
  
    updatedItems[index][field] = value;
    setItems(updatedItems);
  };
  
  const finalTotal = items.reduce((sum, item) => {
    return sum + item.unit_price * item.received_quantity;
  }, 0);

  const handleSubmit = async () => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      toast.error("Authentication token missing. Please log in.");
      return;
    }

    const grnData = {
      purchase_order_id: purchaseOrderID,
      items: items.map(item => ({
        product_id: item.product_id,
        received_quantity: item.received_quantity,
        unit_price: item.unit_price,
        total_price: item.unit_price * item.received_quantity,
      })),
      location_id: selectedLocation,
      total_amount: finalTotal,
    };


    try {
      const response = await axios.post(
        `${API_BASE_URL}/grn/add`,
        grnData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success("GRN created successfully!");
      window.location.reload();
    } catch (error) {
      console.error("Error creating GRN:", error);
      toast.error("Failed to create GRN.");
    }
  }
  
  
  return (
    <div className="container mx-auto p-6">
      <div className="bg-white rounded-lg shadow-lg p-6">
        <h2 className="text-2xl font-bold text-green-700 mb-6">Goods Received Note (GRN)</h2>

        {/* Header */}  
        <div className="grid grid-cols-6 gap-4 font-semibold mb-2 border-b pb-2">
          <div>Product Name</div>
          <div>PO Quanitity</div>
          <div>Remaining  Quantity</div>
          <div>Recieved Quantity</div>
          <div>Unit Price (LKR)</div>
          <div>Total Price (LKR)</div>
        </div>

        {/* Item Rows */}
        {items.map((item, index) => (
          <div key={index} className="grid grid-cols-6 gap-4 mb-3 items-center ">
            <div >
              {item.product_name}
            </div>

            <input
              type="number"
              value={item.quantity}
              className="p-2 border rounded w-full bg-gray-100"
              readOnly
              
            />

            <input
              type="number"
              value={item.remaining_quantity}
              className="p-2 border rounded w-full bg-gray-100"
              readOnly
            />

            <input
              type="number"
              value={item.received_quantity}
              className="p-2 border rounded w-full"
              onChange={(e) => handleChange(index, "received_quantity", parseInt(e.target.value) || 0)}
              max={item.remaining_quantity} 
            />

            <div> {item.unit_price.toFixed(2)}</div>

            <div className="bg-gray-100 p-2 rounded">
              {(item.unit_price * item.received_quantity).toFixed(2)}
            </div>
          </div>
        ))}

        <div className="mb-6">
          <label className="block text-gray-700 font-semibold mb-2">Select Location</label>
          <Select
            options={locations.map((loc) => ({
              value: loc._id,
              label: loc.name || loc.location_name || "Unnamed Location",
            }))}
            value={
              selectedLocation
                ? {
                    value: selectedLocation,
                    label:
                      locations.find((loc) => loc._id === selectedLocation)?.name ||
                      locations.find((loc) => loc._id === selectedLocation)?.location_name ||
                      "Unnamed Location",
                  }
                : null
            }
            onChange={(option) => setSelectedLocation(option.value)}
            placeholder="Select a Location"
            className="w-full"
          />
        </div>

        {/* Final Total */}
        <div className="text-right font-bold text-lg text-green-800 mt-6">
            Final Total: {finalTotal.toFixed(2)}
        </div>

        {/* Submit */}
        <div className="mt-6 text-right">
          <button 
            onClick={handleSubmit}
            disabled={!selectedLocation || items.some(item => item.received_quantity <= 0)}
            className="px-6 py-3 bg-green-700 text-white rounded-lg hover:bg-green-800">
            Submit GRN
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddGRN;
